if (!customElements.get('key-capabilities')) {
  customElements.define(
    'key-capabilities',
    class KeyCapabilities extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = false;
      }

      connectedCallback() {
        if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

        this.selectors = {
          swiper: '.swiper',
          wrapper: '.swiper-wrapper',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination'
        };

        this.swiperEl = this.querySelector(this.selectors.swiper);
        if (!this.swiperEl) return;

        this.wrapper = this.swiperEl.querySelector(this.selectors.wrapper);

        this.desktopColumns = this.parseColumns(this.swiperEl.dataset.pcColumns, 1);
        this.mobileColumns = this.parseColumns(this.swiperEl.dataset.mobileColumns, 1);

        this.enableDesktop = this.swiperEl.dataset.desktopCarousel === 'true';
        this.enableMobile = this.swiperEl.dataset.mobileCarousel === 'true';

        this.totalSlides = this.wrapper?.children.length || 0;
        // ✅ If only one slide, add full-width class
        if (this.totalSlides === 1) {
          this.classList.add('full-width');
        }
        this.mqlDesktop = window.matchMedia('(min-width: 768px)');
        this.mqlDesktop.addEventListener('change', this.init.bind(this));

        this.init();
        // this.initProductControls();
      }

      parseColumns(value, fallback = 1) {
        const parsed = parseFloat(String(value || '').replace(',', '.'));
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
      }

      init() {
        const isDesktop = this.mqlDesktop.matches;
        const enabled = isDesktop ? this.enableDesktop : this.enableMobile;
        // const visibleSlides = isDesktop ? this.desktopColumns : this.mobileColumns;
        if (!enabled) {
          this.destroySlider();
          return;
        }
        this.initSlider();
      }

      initSlider() {
        if (this.sliderInstance) return;

        const nextEl = this.querySelector(this.selectors.nextEl);
        const prevEl = this.querySelector(this.selectors.prevEl);
        const pagination = this.querySelector(this.selectors.pagination);

        const gap = window
          .getComputedStyle(this.wrapper)
          .getPropertyValue('gap');

        const spaceBetween = parseFloat(gap) || 16;
        const pagePadding = parseFloat(
          window.getComputedStyle(this.swiperEl).getPropertyValue('--page-padding')
        ) || 0;
        const slidesOffsetAfter = Math.max(spaceBetween, pagePadding);

        const options = {
          slidesPerView: this.mobileColumns,
          spaceBetween,
          slidesOffsetAfter,
          roundLengths: true,
          threshold: 2,
          watchOverflow: true,

          breakpoints: {
            768: {
              slidesPerView: this.desktopColumns
            }
          },

          navigation:
            nextEl && prevEl
              ? { nextEl, prevEl }
              : false,

          pagination:
            pagination
              ? { el: pagination, clickable: true }
              : false
        };

        this.sliderInstance = new window.FoxTheme.Carousel(
          this.swiperEl,
          options
        );

        this.sliderInstance.init();
      }
      destroySlider() {
        if (!this.sliderInstance) return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      // initProductControls() {
      //   const compareTable = document.querySelector('compare-table');
      //   if (!compareTable) return;

      //   const productCheckboxes = this.querySelectorAll('.product-handle-cheack');

      //   /* ------------------------------
      //     ✅ CHECK ALL BY DEFAULT
      //   ------------------------------ */
      //   productCheckboxes.forEach(input => {
      //     input.checked = true; // check visually

      //     const handle = input.dataset.itemProduct;

      //     const targetButton = compareTable.querySelector(
      //       `.table-name[data-product-name="${handle}"]`
      //     );

      //     if (!targetButton) return;

      //     // Ensure compare-table button is active
      //     if (!targetButton.classList.contains('active')) {
      //       targetButton.classList.add('active');
      //     }
      //   });

      //   // After setting all active → update table columns once
      //   if (typeof compareTable.updateColumns === 'function') {
      //     compareTable.updateColumns();
      //   }

      //   /* ------------------------------
      //     CHECKBOX TOGGLE SYNC
      //   ------------------------------ */
      //   productCheckboxes.forEach(input => {
      //     input.addEventListener('change', (e) => {

      //       const handle = e.target.dataset.itemProduct;

      //       const targetButton = compareTable.querySelector(
      //         `.table-name[data-product-name="${handle}"]`
      //       );

      //       if (!targetButton) return;

      //       const isActive = targetButton.classList.contains('active');

      //       if (e.target.checked && !isActive) {
      //         targetButton.classList.add('active');
      //       }

      //       if (!e.target.checked && isActive) {
      //         targetButton.classList.remove('active');
      //       }

      //       compareTable.updateColumns();
      //     });
      //   });

      //   /* ------------------------------
      //     PIN FEATURE
      //   ------------------------------ */
      //   this.querySelectorAll('.product-handle-pinned').forEach(pinInput => {
      //     pinInput.addEventListener('change', (e) => {

      //       const handle = e.target.dataset.itemProduct;

      //       if (!e.target.checked) return;

      //       // Allow only one pinned
      //       this.querySelectorAll('.product-handle-pinned').forEach(p => {
      //         if (p !== e.target) p.checked = false;
      //       });

      //       this.moveProductToFirst(compareTable, handle);
      //     });
      //   });
      // }


      //   moveProductToFirst(compareTable, handle) {
      //   const table = compareTable.querySelector('table');
      //   if (!table) return;

      //   const headerRow = table.querySelector('thead tr');
      //   const headers = Array.from(headerRow.children);

      //   // Find header index of selected product
      //   const headerIndex = headers.findIndex(
      //       th => th.dataset.productName === handle
      //   );

      //   if (headerIndex === -1) return;

      //   // We always insert after "Specification" column
      //   const specHeader = headers[0];
      //   headerRow.insertBefore(headers[headerIndex], specHeader.nextSibling);

      //   // Now fix body rows
      //   table.querySelectorAll('tbody tr').forEach(row => {
      //       const cells = Array.from(row.children);

      //       // Because tbody has hidden search column at index 1
      //       const bodyIndex = headerIndex + 1;

      //       const targetCell = cells[bodyIndex];
      //       if (!targetCell) return;

      //       // Insert after attribute-name (index 0) + search column (index 1)
      //       row.insertBefore(targetCell, cells[2]);
      //   });
      //   }


      disconnectedCallback() {
        this.destroySlider();
      }
    }
  );
}
